import React from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';
import {List, Item} from './styles';

function ProgressBar({t, steps, currentStep, data}) {
  return (
    <List>
      {steps.map(({name, label}, i) => {
        if (name === 'license' && !data.sellAlcohol) {
          return null;
        }
        
        if (name === 'license') {
          return (
            <Item key={name} className={currentStep === i ? 'active' : ''}>
              <span>{data.season === 'event' ? t('form.steps.licenseInfo.event') : t('form.steps.licenseInfo.normal')}</span>
            </Item>
          );
        }
      
        return (
          <Item key={name} className={currentStep === i ? 'active' : ''}>
            <span>{label}</span>
          </Item>
        );
      })}
    </List>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data
});

export default withNamespaces()(
  connect(mapStateToProps, null)(ProgressBar)
);